var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChapterLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.27 80.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b9cff;}.cls-2{fill:#dcfffa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 40.14,
    cy: 40.14,
    r: 40.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.14,26.34c3.86,0,7,3.14,7,7,0,.63,0,1.32.02,2.06.03,2.63.07,5.9-.3,8.64-.38,2.8-1.01,3.78-1.21,4.03-1.97.02-9.4.03-11.32.04-1.32-2.13-1.23-10-1.2-12.66,0-.75.02-1.45.02-2.1,0-3.86,3.14-7,7-7m0-5c-6.63,0-12,5.37-12,12s-.84,19.76,5.79,19.76c.23,0,12.12-.02,12.36-.05,6.71-.87,5.85-13.32,5.85-19.71s-5.37-12-12-12h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.91,
    y: 37.71,
    width: 28.46,
    height: 19.94
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 40.14,
    cy: 44.88,
    r: 3.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.79 53.77 37.48 53.77 38.71 44.88 41.57 44.88 42.79 53.77"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapterLock);
export default __webpack_public_path__ + "static/media/chapter-lock.f4739e1769333a49c60e1e31fefd8b32.svg";
export { ForwardRef as ReactComponent };